import styles from "./numberInput.module.css";

const NumberInput = ({ value, setValue, placeHolder, className = "" }) => {
  const handleChange = (e) => {
    const number = e.target.value;
    setValue(number);
  };

  return (
    <input
      className={`${styles.numberInput} ${className}`}
      type="Number"
      placeholder={placeHolder}
      value={value}
      onChange={(e) => handleChange(e)}
    />
  );
};

export default NumberInput;
